import React from 'react';
import { HTMLDivAttributesWithRef } from 'domain/models/shared.model';
import styles from './Body.module.css';

export type BodyProps = HTMLDivAttributesWithRef;

const Body = React.forwardRef<HTMLDivElement, BodyProps>(
  ({ className, children, ...props }, ref): JSX.Element | null => (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <div {...props} ref={ref} className={`${styles.root} ${className}`}>
      {children}
    </div>
  )
);

export default Body;
